export default "__VITE_PUBLIC_ASSET__5954191d__"